<template>
  <div v-if="false"><slot /></div>
</template>

<script>
export default {
  name: 'Portal',
  props: {
    to: {
      type: String,
      default: 'body'
    },
  },
  data() {
    return {
      container: null,
      portalVm: null,
      isBeingDestroyed: false,
    };
  },
  mounted() {
    this.createPortal();
  },
  beforeDestroy() {
    this.isBeingDestroyed = true;
    this.destroyPortal();
  },
  methods: {
    createPortal() {
      if (this.container || this.isBeingDestroyed) return;

      this.container = document.createElement('div');
      const target = document.querySelector(this.to) || document.body;
      target.appendChild(this.container);

      this.portalVm = new this.$root.constructor({
        parent: this,
        render: (h) => h('div', {
          attrs: { 'data-portal': true },
          style: { 'pointer-events': 'auto' },
        }, this.$slots.default),
      }).$mount(this.container);
    },
    destroyPortal() {
      if (this.portalVm) {
        this.portalVm.$destroy();
        this.portalVm.$el.remove?.();
        this.portalVm = null;
      }
      if (this.container?.parentNode) {
        this.container.parentNode.removeChild(this.container);
        this.container = null;
      }
    },
  },
  updated() {
    if (this.portalVm) {
      this.portalVm.$forceUpdate();
    }
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        if (!this.isBeingDestroyed) {
          this.destroyPortal();
          this.createPortal();
        }
      });
    },
  },
};
</script>
